function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var NFTOverlayTemplate = require('./nft-overlay.template');
var SaitoOverlay = require('./../../saito-overlay/saito-overlay');
var NFTAtomize = require('./nft-atomize');
var NFTOverlay = /*#__PURE__*/function () {
  function NFTOverlay(app, mod) {
    var _this = this;
    var attach_events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    _classCallCheck(this, NFTOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.overlay.callback_on_close = function () {
      if (_this.atomizer) {
        _this.atomizer.shutdown();
      }
    };

    //
    // ui helpers
    //
    this.nft = null;
    if (attach_events == true) {
      app.connection.on('saito-nft-details-render-request', function (nft) {
        _this.render(nft);
      });
      app.connection.on('saito-nft-details-close-request', function () {
        _this.overlay.close();
      });

      //app.connection.on('saito-disable-nft', (obj) => {
      // obj.nft_id
      // obj.nft_sig
      //});

      //app.connection.on('saito-enable-nft', (obj) => {
      // obj.nft_id
      // obj.nft_sig
      //});
    }
  }
  return _createClass(NFTOverlay, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var nft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (nft) {
        this.nft = nft;
      }
      this.overlay.show(NFTOverlayTemplate(this.app, this.mod, this));
      if (!this.nft.tx_fetched) {
        this.nft.fetchTransaction(function () {
          console.log('Rerendering nft overlay after fetching data');
          _this2.render();
        });
        return;
      }

      // We need to kick this off, so that any child class can finish
      // rendering it's changes to the base class
      setTimeout(function () {
        _this2.attachBaseEvent();
        _this2.attachEvents();
      }, 25);
    }
  }, {
    key: "attachBaseEvent",
    value: function attachBaseEvent() {
      var _this3 = this;
      var header_btn = document.querySelector('.saito-nft-header-btn');

      //
      // header info toggle
      //
      if (header_btn) {
        header_btn.onclick = function (e) {
          var p = document.querySelector('.saito-nft-overlay.panels');
          if (p) {
            if (p.classList.contains('saito-nft-mode-info')) {
              p.classList.remove('saito-nft-mode-info');
            } else {
              p.classList.add('saito-nft-mode-info');
            }
          }
          header_btn.classList.toggle('rotate');
        };
      }
      var merge_btn = document.querySelector('.saito-nft-footer-btn.merge');
      //
      // MERGE button
      //
      if (merge_btn) {
        merge_btn.onclick = /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
            var c;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  _context.n = 1;
                  return sconfirm('Merge all copies of NFT into a single one?');
                case 1:
                  c = _context.v;
                  if (c) {
                    _this3.mergeNFT();
                  }
                // no interstitial
                //document.querySelector('.saito-nft-overlay.panels').classList.add('saito-nft-mode-merge');
                case 2:
                  return _context.a(2);
              }
            }, _callee);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }();
      }

      //
      // split and deposit (info panel)
      //
      var _loop = function _loop() {
        var utxoIdx = z + 1;

        // Split button (works with both old and new structure)
        var splitBtn = document.querySelector(".utxo-split-btn[data-utxo-idx=\"".concat(utxoIdx, "\"]"));
        if (!splitBtn) {
          // Try new structure
          splitBtn = document.querySelector("#utxo_".concat(utxoIdx, " .utxo-split-btn"));
        }
        if (splitBtn) {
          splitBtn.onclick = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
              var idx, panel, overlay;
              return _regenerator().w(function (_context2) {
                while (1) switch (_context2.n) {
                  case 0:
                    idx = parseInt(e.currentTarget.getAttribute('data-utxo-idx')) - 1;
                    _this3.nft.resetNFT(_this3.all_slips[idx]);

                    // Hide all overlays first
                    document.querySelectorAll('.saito-nft-split-overlay').forEach(function (overlay) {
                      overlay.classList.remove('split-overlay-active');
                    });

                    // Remove active class from panel
                    panel = document.querySelector('.saito-nft-panel-info');
                    if (panel) {
                      panel.classList.remove('split-overlay-panel-active');
                    }

                    // Show the specific overlay for this UTXO
                    overlay = document.querySelector(".split-container-utxo-".concat(utxoIdx));
                    if (overlay) {
                      overlay.classList.add('split-overlay-active');
                      // Add active class to panel for CSS targeting
                      if (panel) {
                        panel.classList.add('split-overlay-panel-active');
                      }
                      _this3.showSplitOverlay(utxoIdx);
                    }
                  case 1:
                    return _context2.a(2);
                }
              }, _callee2);
            }));
            return function (_x2) {
              return _ref2.apply(this, arguments);
            };
          }();
        }

        //
        // DELETE button
        //
        var delete_btn = document.querySelector(".utxo-delete-btn[data-utxo-idx=\"".concat(utxoIdx, "\"]"));
        if (delete_btn) {
          delete_btn.onclick = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
              var idx, c, newtx;
              return _regenerator().w(function (_context3) {
                while (1) switch (_context3.n) {
                  case 0:
                    idx = parseInt(e.currentTarget.getAttribute('data-utxo-idx')) - 1;
                    _this3.nft.resetNFT(_this3.all_slips[idx]);
                    _context3.n = 1;
                    return sconfirm("Delete this NFT and recover ".concat(_this3.app.wallet.convertNolanToSaito(_this3.nft.deposit), " SAITO?"));
                  case 1:
                    c = _context3.v;
                    if (c) {
                      _context3.n = 2;
                      break;
                    }
                    return _context3.a(2);
                  case 2:
                    _context3.n = 3;
                    return _this3.app.wallet.createRemoveNFTTransaction(_this3.nft);
                  case 3:
                    newtx = _context3.v;
                    _context3.n = 4;
                    return newtx.sign();
                  case 4:
                    _context3.n = 5;
                    return _this3.app.network.propagateTransaction(newtx);
                  case 5:
                    //
                    // remove any copies of NFT from local archive
                    //
                    _this3.app.storage.deleteTransaction(_this3.nft.tx, null, 'localhost');
                    siteMessage('NFT Deletion in Process...', 2000);
                    _this3.overlay.close();

                    // Close the overlay listing your nfts
                    _this3.app.connection.emit('saito-nft-list-close-request');
                    if (document.querySelector('.nft-list-container')) {
                      _this3.app.connection.emit('saito-nft-list-render-request');
                    }
                  case 6:
                    return _context3.a(2);
                }
              }, _callee3);
            }));
            return function (_x3) {
              return _ref3.apply(this, arguments);
            };
          }();
        }

        // Return button handler
        var returnBtn = document.querySelector(".split-return-button-utxo-".concat(utxoIdx));
        if (returnBtn) {
          returnBtn.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            // Hide the overlay
            var overlay = document.querySelector(".split-container-utxo-".concat(utxoIdx));
            if (overlay) {
              overlay.classList.remove('split-overlay-active');
            }
            // Remove active class from panel
            var panel = document.querySelector('.saito-nft-panel-info');
            if (panel) {
              panel.classList.remove('split-overlay-panel-active');
            }
          };
        }

        // Deposit button (works with both old and new structure)
        var depositBtn = document.querySelector(".utxo-deposit-btn[data-utxo-idx=\"".concat(utxoIdx, "\"]"));
        if (!depositBtn) {
          // Try new structure
          depositBtn = document.querySelector("#utxo_".concat(utxoIdx, " .utxo-deposit-btn"));
        }
        if (depositBtn) {
          depositBtn.onclick = /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(e) {
              var idx, depositAmount;
              return _regenerator().w(function (_context4) {
                while (1) switch (_context4.n) {
                  case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    salert('Deposit functionality is not yet fully implemented. Please check wallet.createDepositNFTTransaction()');
                    return _context4.a(2);
                  case 1:
                    depositAmount = _context4.v;
                    if (!(!depositAmount || isNaN(Number(depositAmount)) || Number(depositAmount) <= 0)) {
                      _context4.n = 2;
                      break;
                    }
                    return _context4.a(2);
                  case 2:
                    try {
                      // Create deposit transaction
                      // Note: This may need to be implemented in the wallet module
                      // For now, we'll show an alert that this feature needs implementation
                      // TODO: Implement deposit transaction creation
                      // let tx = await this.app.wallet.createDepositNFTTransaction(deposit_nft, depositAmount);
                      // await tx.sign();
                      // await this.app.network.propagateTransaction(tx);
                      // siteMessage('Deposit transaction sent', 2000);
                      // this.render();
                    } catch (err) {
                      console.error(err);
                      salert('Failed to create deposit transaction: ' + ((err === null || err === void 0 ? void 0 : err.message) || err));
                    }
                  case 3:
                    return _context4.a(2);
                }
              }, _callee4);
            }));
            return function (_x4) {
              return _ref4.apply(this, arguments);
            };
          }();
        }
      };
      for (var z = 0; z < this.all_slips.length; z++) {
        _loop();
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this$app$options,
        _this4 = this;
      //
      // buttons
      //
      var send_btn = document.querySelector('.saito-nft-footer-btn.send-nft');
      var enable_btn = document.querySelector('.saito-nft-footer-btn.enable-nft');
      var disable_btn = document.querySelector('.saito-nft-footer-btn.disable-nft');

      //
      // contextual confirm buttons
      //
      var cancel_send_btn = document.querySelector('.saito-nft-panel-send .saito-nft-cancel-btn');
      var confirm_send_btn = document.querySelector('.saito-nft-panel-send .saito-nft-confirm-btn');

      //
      // enable / disable
      //
      var can_enable = false;
      var can_disable = false;
      if (this.nft.css || this.nft.js) {
        can_enable = true;
      }
      if ((_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && (_this$app$options = _this$app$options.permissions) !== null && _this$app$options !== void 0 && _this$app$options.nfts) {
        if (this.app.options.permissions.nfts.includes(this.nft.tx_sig)) {
          can_enable = false;
          can_disable = true;
        }
      }
      enable_btn.style.display = can_enable ? 'flex' : 'none';
      disable_btn.style.display = can_disable ? 'flex' : 'none';

      //
      // SEND NFT
      //
      if (confirm_send_btn) {
        // Select a shard
        Array.from(document.querySelectorAll('.saito-nft-panel-send .nft-slip-box')).forEach(function (box) {
          box.onclick = function (e) {
            if (!e.currentTarget.classList.contains('selected-shard')) {
              document.querySelector('.selected-shard').classList.remove('selected-shard');
              e.currentTarget.classList.add('selected-shard');
            }
          };
        });

        // Click to send
        confirm_send_btn.onclick = /*#__PURE__*/function () {
          var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(e) {
            var rec_in, receiver, selected_shard, idx, _this4$nft, newtx, nft_type, handlers, _iterator, _step, modobj, _t, _t2, _t3;
            return _regenerator().w(function (_context5) {
              while (1) switch (_context5.p = _context5.n) {
                case 0:
                  e.preventDefault();
                  rec_in = document.querySelector('#nft-receiver-address');
                  receiver = rec_in ? rec_in.value.trim() : '';
                  if (_this4.app.wallet.isValidPublicKey(receiver)) {
                    _context5.n = 1;
                    break;
                  }
                  salert('Receiver’s public key is not valid');
                  return _context5.a(2);
                case 1:
                  selected_shard = document.querySelector('.saito-nft-panel-send .selected-shard');
                  if (selected_shard) {
                    _context5.n = 2;
                    break;
                  }
                  salert('Please select which shard you want to send');
                  return _context5.a(2);
                case 2:
                  idx = parseInt(selected_shard.getAttribute('data-utxo-idx')) - 1;
                  _this4.nft.resetNFT(_this4.all_slips[idx]);
                case 3:
                  _context5.p = 3;
                  _context5.n = 4;
                  return _this4.app.wallet.createSendNFTTransaction(_this4.nft, receiver);
                case 4:
                  newtx = _context5.v;
                  nft_type = (_this4$nft = _this4.nft) === null || _this4$nft === void 0 ? void 0 : _this4$nft.nft_type;
                  console.log('about to go into looking for this nft-type: ' + nft_type);
                  handlers = _this4.app.modules.getRespondTos('saito-nft-transfer', _this4.nft);
                  _iterator = _createForOfIteratorHelper(handlers);
                  _context5.p = 5;
                  _iterator.s();
                case 6:
                  if ((_step = _iterator.n()).done) {
                    _context5.n = 12;
                    break;
                  }
                  modobj = _step.value;
                  if (!(!(modobj !== null && modobj !== void 0 && modobj["class"]) || !modobj["class"].includes(nft_type) || !nft_type)) {
                    _context5.n = 7;
                    break;
                  }
                  console.log('no class or incude type found... ');
                  return _context5.a(3, 11);
                case 7:
                  if (!(typeof modobj.onTransfer === 'function')) {
                    _context5.n = 11;
                    break;
                  }
                  console.log('running ontransfer...');
                  _context5.p = 8;
                  _context5.n = 9;
                  return modobj.onTransfer(_this4.nft, newtx, receiver);
                case 9:
                  newtx = _context5.v;
                  _context5.n = 11;
                  break;
                case 10:
                  _context5.p = 10;
                  _t = _context5.v;
                  console.error('onTransfer() failed in module...');
                  salert("NFT transfer blocked by module...");
                  return _context5.a(2);
                case 11:
                  _context5.n = 6;
                  break;
                case 12:
                  _context5.n = 14;
                  break;
                case 13:
                  _context5.p = 13;
                  _t2 = _context5.v;
                  _iterator.e(_t2);
                case 14:
                  _context5.p = 14;
                  _iterator.f();
                  return _context5.f(14);
                case 15:
                  _context5.n = 16;
                  return newtx.sign();
                case 16:
                  _context5.n = 17;
                  return _this4.app.network.propagateTransaction(newtx);
                case 17:
                  siteMessage("NFT sent to ".concat(receiver), 3000);
                  _this4.overlay.close();
                  if (document.querySelector('.nft-list-container')) {
                    _this4.app.connection.emit('saito-nft-list-render-request');
                  }
                  _context5.n = 19;
                  break;
                case 18:
                  _context5.p = 18;
                  _t3 = _context5.v;
                  console.error(_t3);
                  salert('Failed to send NFT');
                case 19:
                  return _context5.a(2);
              }
            }, _callee5, null, [[8, 10], [5, 13, 14, 15], [3, 18]]);
          }));
          return function (_x5) {
            return _ref5.apply(this, arguments);
          };
        }();
      }

      //
      // SEND button
      //
      if (send_btn) {
        send_btn.onclick = function (e) {
          document.querySelector('.saito-nft-overlay.panels').classList.add('saito-nft-mode-send');
        };
      }
      if (cancel_send_btn) {
        cancel_send_btn.onclick = function (e) {
          document.querySelector('.saito-nft-overlay.panels').classList.remove('saito-nft-mode-send');
        };
      }

      //
      // Enable button
      //
      if (enable_btn) {
        enable_btn.onclick = function (e) {
          if (!_this4.app.options.permissions) _this4.app.options.permissions = {};
          if (!_this4.app.options.permissions.nfts) _this4.app.options.permissions.nfts = [];
          if (!_this4.app.options.permissions.nfts.includes(_this4.nft.tx_sig)) {
            _this4.app.options.permissions.nfts.push(_this4.nft.tx_sig);
            salert('NFT Activated for Next Reload');
            _this4.app.storage.saveOptions();
          }
          _this4.app.connection.emit('saito-enable-nft', {
            nft_id: _this4.nft.id,
            nft_sig: _this4.nft.tx_sig
          });
          _this4.render();
        };
      }

      //
      // Disable button
      //
      if (disable_btn) {
        disable_btn.onclick = function (e) {
          if (!_this4.app.options.permissions) _this4.app.options.permissions = {};
          if (!_this4.app.options.permissions.nfts) _this4.app.options.permissions.nfts = [];
          _this4.app.options.permissions.nfts = _this4.app.options.permissions.nfts.filter(function (v) {
            return v !== _this4.nft.tx_sig;
          });
          _this4.app.connection.emit('saito-disable-nft', {
            nft_id: _this4.nft.id,
            nft_sig: _this4.nft.tx_sig
          });
          salert('NFT Disabled for Next Reload');
          _this4.app.storage.saveOptions();
          _this4.render();
        };
      }
    }
  }, {
    key: "mergeNFT",
    value: function () {
      var _mergeNFT = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var tx, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return this.app.wallet.createMergeNFTTransaction(this.nft);
            case 1:
              tx = _context6.v;
              _context6.n = 2;
              return tx.sign();
            case 2:
              _context6.n = 3;
              return this.app.network.propagateTransaction(tx);
            case 3:
              if (!this.app.options.wallet.nftMergeIntents) {
                this.app.options.wallet.nftMergeIntents = {};
              }
              this.app.options.wallet.nftMergeIntents[this.nft.id] = Date.now();
              this.app.wallet.saveWallet();
              siteMessage('Merge NFT tx sent', 2000);
              this.overlay.close();
              if (document.querySelector('.nft-list-container')) {
                this.app.connection.emit('saito-nft-list-render-request');
              }
              _context6.n = 5;
              break;
            case 4:
              _context6.p = 4;
              _t4 = _context6.v;
              console.error(_t4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 4]]);
      }));
      function mergeNFT() {
        return _mergeNFT.apply(this, arguments);
      }
      return mergeNFT;
    }() //
    // Decode slip3.public_key to extract original creation block_id and tx_ordinal
    //
  }, {
    key: "decodeSlip3CreationInfo",
    value: function decodeSlip3CreationInfo() {
      var _this$nft;
      if (!((_this$nft = this.nft) !== null && _this$nft !== void 0 && (_this$nft = _this$nft.slip3) !== null && _this$nft !== void 0 && _this$nft.public_key)) {
        return {
          block_id: null,
          tx_ordinal: null
        };
      }
      try {
        var _this$app;
        // Use the NFT's base58ToBytes method if available, otherwise use our own
        var bytes = null;
        if (this.nft.base58ToBytes) {
          bytes = this.nft.base58ToBytes(this.nft.slip3.public_key);
        } else if ((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.crypto) !== null && _this$app !== void 0 && _this$app.fromBase58) {
          // Use app's crypto utility
          var hex = this.app.crypto.fromBase58(this.nft.slip3.public_key);
          bytes = this.hexToBytes(hex);
        } else {
          // Fallback: try to use hex if it's already bytes
          if (typeof this.nft.slip3.public_key === 'string' && /^[0-9a-fA-F]{66}$/.test(this.nft.slip3.public_key)) {
            bytes = this.hexToBytes(this.nft.slip3.public_key);
          } else {
            // Try our own base58 decoder
            bytes = this.base58ToBytes(this.nft.slip3.public_key);
          }
        }
        if (!bytes || bytes.length < 16) {
          return {
            block_id: null,
            tx_ordinal: null
          };
        }

        // Extract block_id (bytes 0-7, big-endian u64)
        var blockIdBytes = bytes.slice(0, 8);
        var block_id = 0n;
        for (var i = 0; i < 8; i++) {
          block_id = block_id << 8n | BigInt(blockIdBytes[i]);
        }

        // Extract tx_ordinal (bytes 8-15, big-endian u64)
        var txOrdBytes = bytes.slice(8, 16);
        var tx_ordinal = 0n;
        for (var _i = 0; _i < 8; _i++) {
          tx_ordinal = tx_ordinal << 8n | BigInt(txOrdBytes[_i]);
        }
        return {
          block_id: block_id.toString(),
          tx_ordinal: tx_ordinal.toString()
        };
      } catch (err) {
        console.error('Error decoding slip3 creation info:', err);
        return {
          block_id: null,
          tx_ordinal: null
        };
      }
    }

    //
    // Helper to convert hex string to bytes
    //
  }, {
    key: "hexToBytes",
    value: function hexToBytes(hex) {
      var clean = hex.startsWith('0x') ? hex.slice(2) : hex;
      var out = new Uint8Array(clean.length / 2);
      for (var i = 0; i < out.length; i++) {
        out[i] = parseInt(clean.substr(i * 2, 2), 16);
      }
      return out;
    }

    //
    // Base58 decoder (fallback if NFT doesn't have it)
    //
  }, {
    key: "base58ToBytes",
    value: function base58ToBytes(str) {
      var B58_ALPHABET = '123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
      var B58_MAP = function () {
        var m = new Map();
        for (var i = 0; i < B58_ALPHABET.length; i++) m.set(B58_ALPHABET[i], i);
        return m;
      }();
      var zeros = 0;
      while (zeros < str.length && str[zeros] === '1') zeros++;
      var bytes = [];
      for (var i = zeros; i < str.length; i++) {
        var val = B58_MAP.get(str[i]);
        if (val == null) throw new Error('Invalid Base58 character');
        var carry = val;
        for (var j = 0; j < bytes.length; j++) {
          var x = bytes[j] * 58 + carry;
          bytes[j] = x & 0xff;
          carry = x >> 8;
        }
        while (carry > 0) {
          bytes.push(carry & 0xff);
          carry >>= 8;
        }
      }
      for (var k = 0; k < zeros; k++) bytes.push(0);
      bytes.reverse();
      return new Uint8Array(bytes);
    }

    //
    // Extract metadata from txmsg (excluding data subobject, title, and description)
    //
  }, {
    key: "extractMetadata",
    value: function extractMetadata() {
      var _this$nft2;
      if (!((_this$nft2 = this.nft) !== null && _this$nft2 !== void 0 && _this$nft2.tx)) {
        return {};
      }
      var txmsg = this.nft.tx.returnMessage();
      if (!txmsg) {
        return {};
      }
      var metadata = {};
      var dataKeys = txmsg.data ? Object.keys(txmsg.data) : [];
      var excludeKeys = ['title', 'description'].concat(_toConsumableArray(dataKeys));
      for (var key in txmsg) {
        if (!excludeKeys.includes(key) && key !== 'data') {
          metadata[key] = txmsg[key];
        }
      }
      return metadata;
    }
  }, {
    key: "showSplitOverlay",
    value: function showSplitOverlay(utxoIdx) {
      var _this5 = this;
      if (!utxoIdx) {
        return;
      }
      var totalAmount = Number(this.nft.amount);
      if (!Number.isFinite(totalAmount) || totalAmount < 2) {
        salert('This NFT cannot be split (amount < 2).');
        return;
      }

      // Get the specific slider elements for this UTXO
      var slider = document.querySelector("#split-slider-utxo-".concat(utxoIdx));
      var leftDiv = document.querySelector("#split-left-utxo-".concat(utxoIdx));
      var bar = document.querySelector("#split-bar-utxo-".concat(utxoIdx));
      var rightDiv = document.querySelector("#split-right-utxo-".concat(utxoIdx));
      var leftNumberBox = document.querySelector("#split-number-left-utxo-".concat(utxoIdx));
      var rightNumberBox = document.querySelector("#split-number-right-utxo-".concat(utxoIdx));
      var confirmSplitButton = document.querySelector(".split-button-utxo-".concat(utxoIdx));
      var atomizeButton = document.querySelector(".atomize-button-utxo-".concat(utxoIdx));
      if (!slider || !leftDiv || !bar || !rightDiv || !leftNumberBox || !rightNumberBox || !confirmSplitButton) {
        console.error('Slider elements not found for UTXO', utxoIdx);
        return;
      }

      // Wait for layout to settle before calculating dimensions
      setTimeout(function () {
        //
        // GET REAL WIDTH
        //
        var parentWidth = slider.getBoundingClientRect().width;
        var barRect = bar.getBoundingClientRect();
        var barWidth = barRect.width;
        var usable = parentWidth - barWidth;
        var minW = 20;

        //
        // INITIAL VALUES
        //
        var leftCount = Math.round(totalAmount / 2);
        var rightCount = totalAmount - leftCount;
        var leftW = usable * (leftCount / totalAmount);
        var rightW = usable - leftW;
        leftDiv.style.width = leftW + 'px';
        rightDiv.style.width = rightW + 'px';

        // Update number boxes instead of split halves
        leftNumberBox.innerHTML = leftCount;
        rightNumberBox.innerHTML = rightCount;

        //
        // CONFIRM BUTTON
        //
        confirmSplitButton.onclick = /*#__PURE__*/function () {
          var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(e) {
            var L, T, R, tx, _t5;
            return _regenerator().w(function (_context7) {
              while (1) switch (_context7.p = _context7.n) {
                case 0:
                  e.preventDefault();
                  L = parseInt(leftNumberBox.innerText);
                  T = parseInt(_this5.nft.amount);
                  R = T - L;
                  _context7.p = 1;
                  _context7.n = 2;
                  return _this5.app.wallet.createSplitNFTTransaction(_this5.nft, L, R);
                case 2:
                  tx = _context7.v;
                  _context7.n = 3;
                  return tx.sign();
                case 3:
                  _context7.n = 4;
                  return _this5.app.network.propagateTransaction(tx);
                case 4:
                  siteMessage('Split NFT tx sent', 2000);
                  _this5.overlay.close();
                  if (document.querySelector('.nft-list-container')) {
                    _this5.app.connection.emit('saito-nft-list-render-request');
                  }
                  _context7.n = 6;
                  break;
                case 5:
                  _context7.p = 5;
                  _t5 = _context7.v;
                  console.error(_t5);
                  _this5.app.browser.safeConsole('NFT: ', _this5.nft, 'debug');
                case 6:
                  return _context7.a(2);
              }
            }, _callee7, null, [[1, 5]]);
          }));
          return function (_x6) {
            return _ref6.apply(this, arguments);
          };
        }();
        if (atomizeButton) {
          atomizeButton.onclick = /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(e) {
              var this_nft;
              return _regenerator().w(function (_context8) {
                while (1) switch (_context8.n) {
                  case 0:
                    _this5.atomize_in_progress = true;
                    this_nft = _this5.all_slips[utxoIdx - 1];
                    if (this_nft) {
                      _context8.n = 1;
                      break;
                    }
                    return _context8.a(2);
                  case 1:
                    _this5.atomizer_ui = new NFTAtomize(_this5.app, _this5.mod, '.split-container-utxo-' + utxoIdx, this_nft, utxoIdx);
                    _this5.atomizer_ui.render();
                  case 2:
                    return _context8.a(2);
                }
              }, _callee8);
            }));
            return function (_x7) {
              return _ref7.apply(this, arguments);
            };
          }();
        }

        //
        // DRAG FUNCTION
        //
        var drag = function drag(e) {
          var rect = slider.getBoundingClientRect();
          var x = e.clientX - rect.left;
          var newLeftW = x;
          newLeftW = Math.max(minW, Math.min(newLeftW, usable - minW));
          var newRightW = usable - newLeftW;
          leftDiv.style.width = newLeftW + 'px';
          rightDiv.style.width = newRightW + 'px';
          leftCount = Math.round(newLeftW / usable * totalAmount);
          leftCount = Math.max(1, Math.min(leftCount, totalAmount - 1));
          rightCount = totalAmount - leftCount;

          // Update number boxes instead of split halves
          leftNumberBox.innerHTML = leftCount;
          rightNumberBox.innerHTML = rightCount;
        };

        //
        // ATTACH EVENT HANDLERS
        //
        bar.onmousedown = function (e) {
          e.preventDefault();
          e.stopPropagation();
          document.addEventListener('mousemove', drag);
          document.addEventListener('mouseup', function () {
            document.removeEventListener('mousemove', drag);
          }, {
            once: true
          });
        };

        // Ensure bar is clickable
        bar.style.pointerEvents = 'auto';
        bar.style.position = 'relative';
        bar.style.zIndex = '11';
      }, 50);
    }
  }]);
}();
module.exports = NFTOverlay;